import styles from './FJCreationPanelFooter.module.less';
import FJShareSettingIcon from '../../../../assets/svg/community/publish.svg?react';
import FJPrivacySetting from '../../../FJCommunity/FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import classNames from 'classnames';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton.jsx';
import DownloadIcon from '../../../../assets/svg/download_black.svg?react';
import VideoIcon from '../../../../assets/svg/video-edit.svg?react';
import FJMultiSourceDownloadButtonContainer from '../../../../common/combineComponents/FJMultiSourceDownloadButton/FJMultiSourceDownloadButtonContainer.jsx';
import EditNameIcon from '../../../../assets/base64/edit-name.svg?react';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import AddMediaIcon from '../../../../assets/svg/add-to-media.svg?react';
import FJUtil from '../../../../util/FJUtil.js';

const FJCreationPanelFooter = props => {
    const {
        isShowPrivacyStatus,
        privacyStatus,
        onPrivacySettingChange,
        shareKey,
        onDownload,
        isDownloading,
        imageToVideo,
        appType,
        continueEdit,
        shareToSociety,
        onAddToMedia,
    } = props;
    const _renderRight = () => {
        return (
            <div className={styles.right}>
                {appType === FJAppConstant.AI_PHOTO_EDITOR && (
                    <FJButton
                        onClick={continueEdit}
                        className={classNames(styles.normal_btn)}
                        textClassName={styles.button_text}
                        text={FJLocalStore._('continue-editing')}
                        type={FJButtonType.DEFAULT}
                        icon={<EditNameIcon />}
                    />
                )}

                <FJButton
                    onClick={imageToVideo}
                    className={classNames(styles.normal_btn)}
                    textClassName={styles.button_text}
                    text={FJLocalStore._(appType === FJAppConstant.AI_VIDEO_GENERATOR ? 'edit' : 'image-to-video')}
                    type={FJButtonType.DEFAULT}
                    icon={<VideoIcon />}
                />

                <div className={styles.line} />
                {appType === FJAppConstant.TEXT_TO_IMAGE && <FJMultiSourceDownloadButtonContainer />}
                {appType !== FJAppConstant.TEXT_TO_IMAGE && (
                    <FJButton
                        className={classNames(styles.download_button_box)}
                        type={FJButtonType.GRADIENT}
                        textClassName={styles.button_text}
                        text={FJLocalStore._('download')}
                        icon={<DownloadIcon className={styles.download_icon} />}
                        onClick={onDownload}
                        isLoading={isDownloading}
                    />
                )}
            </div>
        );
    };
    const _renderEditPageRight = () => {
        return (
            <div className={styles.right}>
                {appType === FJAppConstant.AI_PHOTO_EDITOR && (
                    <FJButton
                        onClick={continueEdit}
                        className={classNames(styles.normal_btn)}
                        textClassName={styles.button_text}
                        text={FJLocalStore._('continue-editing')}
                        type={FJButtonType.DEFAULT}
                        icon={<EditNameIcon />}
                    />
                )}

                {appType !== FJAppConstant.TEXT_TO_IMAGE && (
                    <FJButton
                        className={classNames(styles.normal_btn)}
                        textClassName={styles.button_text}
                        type={FJButtonType.DEFAULT}
                        text={FJLocalStore._('download')}
                        icon={<DownloadIcon />}
                        onClick={onDownload}
                        isLoading={isDownloading}
                    />
                )}
                {appType === FJAppConstant.TEXT_TO_IMAGE && <FJMultiSourceDownloadButtonContainer />}
                <div className={styles.line} />

                <FJButton
                    className={classNames(styles.download_button_box)}
                    type={FJButtonType.GRADIENT}
                    textClassName={styles.button_text}
                    text={FJLocalStore._('add-to-media')}
                    icon={<AddMediaIcon />}
                    onClick={onAddToMedia}
                />
            </div>
        );
    };

    return (
        <div className={styles.box}>
            {isShowPrivacyStatus ? (
                <FJPrivacySetting
                    value={privacyStatus}
                    onChange={onPrivacySettingChange}
                    isTopLayer={true}
                    placement='topLeft'
                    offsetTop={-10}
                    shareKey={shareKey}
                    renderTrigger={({ ref, onClick }) => {
                        return (
                            <div className={styles.text_icon_btn} ref={ref} onClick={onClick}>
                                <FJShareSettingIcon />
                                {FJLocalStore._('visibility')}
                            </div>
                        );
                    }}
                />
            ) : (
                <div />
            )}
            {FJUtil.isEditPage() ? _renderEditPageRight() : _renderRight()}
        </div>
    );
};

export default FJCreationPanelFooter;
